import { render, staticRenderFns } from "./cleaned-results.vue?vue&type=template&id=63ee88ac"
import script from "./cleaned-results.vue?vue&type=script&lang=js"
export * from "./cleaned-results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports